import { makeStyles } from '@material-ui/core/styles';
import { orange } from 'styles/abstract/variables';

export const makeLabelClasses = makeStyles({
    root: {
        '&.Mui-focused': {
            color: 'inherit',
        },
    },
});

export const makeOutlinedInputClasses = makeStyles({
    root: {
        fontSize: '0.875rem',
        marginRight: '1rem',

        '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: orange,
        },

        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: orange,
            borderWidth: '0.0625rem',
        },
    },
    input: {
        padding: '0.875rem 1rem',

        '&.MuiOutlinedInput-inputMultiline': {
            padding: 0,
        },

        '&[type="number"]': {
            padding: '0rem 0.2rem 0rem 1rem',
            width: '3.8rem',
            height: '2.75rem'
        }
    },
});
